module.exports = __webpack_public_path__ + "img/7_165.99286b25.png";